import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ProgressBarModule } from "primeng/progressbar";
import { TabViewModule } from "primeng/tabview";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { ButtonModule } from "primeng/button";
import { MessageModule } from "primeng/message";
import { ToolbarModule } from "primeng/toolbar";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { AccordionModule } from "primeng/accordion";
import { MessageService } from "primeng/api";
import { MessagesModule } from "primeng/messages";
import { ToastModule } from "primeng/toast";
import { InputSwitchModule } from "primeng/inputswitch";
import { AutoCompleteModule } from "primeng/autocomplete";
import { RadioButtonModule } from "primeng/radiobutton";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CheckboxModule } from "primeng/checkbox";
import { TableModule } from "primeng/table";
import { EditorModule } from "primeng/editor";
import { CardModule } from "primeng/card";
import { AutocompleteModule } from "../shared/modules/autocomplete/autocomplete.module";
import { AppMainComponent } from "./components/app.main.component";
import { AppMenuComponent } from "./components/app.menu.component";
import { AppMenuitemComponent } from "./components/app.menuitem.component";
import { AppRightMenuComponent } from "./components/app.right-menu.component";
import { AppTopBarComponent } from "./components/app.topbar.component";
import { AppFooterComponent } from "./components/app.footer.component";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";
import { MultiSelectModule } from 'primeng/multiselect';
import {OrderListModule} from "primeng/orderlist";
import {DialogModule} from "primeng/dialog";
import {FileUploadModule} from "primeng/fileupload";
import {TooltipModule} from "primeng/tooltip";

const PRIMENG_MODULES = [
  ProgressBarModule,
  TabViewModule,
  InputTextModule,
  PasswordModule,
  ButtonModule,
  MessageModule,
  MessagesModule,
  ToolbarModule,
  CalendarModule,
  DropdownModule,
  AccordionModule,
  ToastModule,
  InputSwitchModule,
  AutoCompleteModule,
  RadioButtonModule,
  ConfirmDialogModule,
  ProgressSpinnerModule,
  CheckboxModule,
  TableModule,
  EditorModule,
  AutocompleteModule,
  CardModule,
  MultiSelectModule,
  OrderListModule,
  DialogModule,
  FileUploadModule,
  TooltipModule
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    ...PRIMENG_MODULES
  ],
  exports: [
    CommonModule,
    FormsModule,
    ...PRIMENG_MODULES
  ],
  declarations: [
    AppMainComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppRightMenuComponent,
    AppTopBarComponent,
    AppFooterComponent,
  ],
  providers: [MessageService, ConfirmationService],
})
export class PrimeNgModule {}
